import React from 'react';

export default function Loading() {
  return (
    <div className="col-12">
      <div className="row gy-3">
        {Array.from({ length: 12 }, (_, index) => (
          <div key={index} className="col-md-6 col-xl-4">
            <div className="item animate-pulse">
              <div className="item-inner item-inner-secondary">
                <div className="mb-0 h2" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
